import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Layout from "src/components/layout/dashboard/Layout";
import PlanFormModal from "./PlanFormModal";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as planActions from "src/redux/slices/planSlice";
import { toast } from "react-toastify";

// Bookmarkable edit URL (/admin/plans/:planId/edit) — fetches the plan,
// then renders it through the same PlanFormModal the list page's pencil
// icon opens, so create and edit never fall out of sync again.
const PlanForm: React.FC = () => {
  const { planId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { planDetails } = useAppSelector((state) => state.plan);

  useEffect(() => {
    if (planId) {
      dispatch(planActions.getPlanDetailsRequest(planId));
    }
    return () => {
      dispatch(planActions.resetPlanDetails());
    };
  }, [dispatch, planId]);

  useEffect(() => {
    if (planDetails.error) {
      toast.error("Failed to fetch plan details");
    }
  }, [planDetails.error]);

  const handleClose = () => navigate("/admin/plans/list");

  return (
    <Layout
      type="admin"
      meta={{
        title: "Edit Plan | Invyntra",
        description: "Edit subscription plan details.",
        keywords: "plans, pricing, invyntra",
      }}
    >
      {planDetails.loading || !planDetails.data ? (
        <div className="py-16 text-center text-sm text-gray-500 dark:text-gray-400">
          Loading plan…
        </div>
      ) : (
        <PlanFormModal open onClose={handleClose} plan={planDetails.data} />
      )}
    </Layout>
  );
};

export default PlanForm;
